export default [
    {
        label: 'Stratum A',
        key: 0,
    },

    {
        label: 'Stratum B',
        key: 1,
    },
];
